// extracted by mini-css-extract-plugin
export var dividerLine = "_5j-0";
export var errorBackground = "_5j-1";